import Vue from 'vue'

import store from '@/store'
import VueNotifications from './plugin'

Vue.use(VueNotifications, {
	store,
})
